import { useQuery, UseQueryResult } from "react-query";

import { getMappedCptCodes, MappedCptCodes } from "api/insurancePlanCptCodes";

interface UseGetMappedCptCodesReturn {
  mappedCptCodes: MappedCptCodes | null;
  mappedCptCodesLoading: boolean;
  mappedCptCodesFetching: boolean;
  refetchMappedCptCodes: () => void;
}

const useGetMappedCptCodes = (
  planId?: number
): UseGetMappedCptCodesReturn &
  Omit<UseQueryResult, "data" | "isLoading" | "isFetching" | "refetch"> => {
  const { data, isLoading, isFetching, refetch, ...rest } = useQuery(
    ["mappedCptCodes", planId],
    () => getMappedCptCodes(planId!),
    {
      enabled: Boolean(planId),
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  return {
    mappedCptCodes: (data?.data as MappedCptCodes) ?? null,
    mappedCptCodesLoading: isLoading,
    mappedCptCodesFetching: isFetching,
    refetchMappedCptCodes: refetch,
    ...rest,
  };
};

export default useGetMappedCptCodes;
